import { MinimalPanelFragment } from 'src/graphql/generated/graphql'

export const getIsBackPanelLandscape = (panels: MinimalPanelFragment[]) => {
  const backPanel = panels.find(panel => panel.name === 'Back')
  if (backPanel && backPanel.height < backPanel.width) return true
  return false
}
